import { useQuery } from '@tanstack/react-query';
import { fetchData } from '../../../utils';
import useError from '../../useError';
import useSmartlook from '../../useSmartlook';

export default function useAgreementQuery({
  amount,
  term,
  fileType,
  enabled = true,
}: {
  amount?: number;
  term?: number;
  fileType: 'PDF' | 'HTML';
  enabled?: boolean;
}) {
  const { error } = useSmartlook();
  const { showError } = useError();
  return useQuery<Blob | string | null>({
    queryKey: [
      'agreement',
      {
        amount,
        term,
        fileType,
      },
    ],
    queryFn: async () => {
      if (!amount || !term) {
        return null;
      }

      const strObj = {
        amount: `${amount}`,
        term: `${term}`,
        fileType,
      };

      try {
        const urlParams = new URLSearchParams(strObj).toString();
        const res = await fetchData(
          `/client/agreements/preliminary?${urlParams}`,
          {
            headers: {
              'Content-Type':
                fileType === 'PDF' ? 'application/pdf' : 'text/html',
            },
          },
        );
        return fileType === 'PDF' ? (res as Blob) : (res as string);
      } catch (e) {
        error(
          '[useAgreementQuery][GET /client/agreements/preliminary?{urlParams}]',
          e,
        );
        showError();
        throw e;
      }
    },
    staleTime: Infinity,
    enabled,
  });
}
